import { Button, CircularProgress, Divider, Grid } from '@material-ui/core';
import { Card, Icons, Typography } from '@nutrien/cxp-components';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useMemo, useState } from 'react';
import { Subscription } from 'rxjs';

import { saveReportAndGetS3Path } from '../../graphql';
import { ReportInfoInput } from '../../graphql/Reports';
import { useMst } from '../../mobx-models/Root';
import { Discipline } from '../../models/models';
import useAssetDetails from '../../rxdb/assetDetails/useAssetDetails';
import useAssetsByAreaHierarchy from '../../rxdb/assetsByAreaHeirachy/useAssetsByAreaHierarchy';
/* 
  Planned Deficiency Related code commented in this file. It's for future use.
 */
//import { PlannedDeficiencyListDocument } from '../../rxdb/existingDeficiencyList/queryBuilder';
//import { useExestingDeficiencyList } from '../../rxdb/existingDeficiencyList/useExestingDeficiencyList';
import {
  InspectionFiles as InspectionFilesType,
  InspectionFilesDocument,
} from '../../rxdb/inspectionFiles/queryBuilder';
import { useInspectionFiles } from '../../rxdb/inspectionFiles/useInspectionFiles';
import { MobileComponentLocationHeirarchy } from '../../rxdb/inspectionList/queryBuilder';
import useSelectedInspection from '../../rxdb/inspectionList/useSelectedInspection';
import { LineandSectionPropertiesListDocument } from '../../rxdb/lineandSectionPropertiesDetails/queryBuilder';
import { useLineAndSectionProperties } from '../../rxdb/lineandSectionPropertiesDetails/useLineAndSectionProperties';
import usePreviousReportFiles from '../../rxdb/previousReports/usePreviousReport';
import useAccessOnTask from '../../rxdb/taskList/useAccessOnTask';
import { useNotification, useOnlineStatus } from '../../utilities';
import { IMAGE_PATH } from '../../utilities/constants';
import { trackEventFn, TrackingEventType } from '../../utilities/hooks/useEventTracking';
import { getImage } from '../../utilities/useFileStorage';
import {
  downloadURI,
  getDisciplineById,
  getValueFromLocalStorage,
  setValueinLocalStorage,
} from '../../utilities/utilityFunctions';
import AssetLocationDetails from '../AssetLocationDetails';
import AssetProperties from '../AssetProperties';
import Auditlogs from '../AuditLogs';
import DynamicProperty from '../DynamicProperty';
import ElectricalAssetLocationDetails from '../ElectricalAssetLocationDetails';
import EtapProperties from '../EtapProperties';
import InspectionFiles from '../InspectionFiles';
import LineAndSectionProperties from '../LineAndSectionProperties';
import OfflineDialog from '../OfflineDialog';
//import PlannedDeficiency from './plannedDeficiency';
import PreviousReports from '../PreviousReports';
import useStyles from './InspectionDetails.styles';

const InspectionDetails: React.FC = () => {
  const classes = useStyles();
  const isOnline = useOnlineStatus();
  const { errorNotification } = useNotification();
  const { HandleGesture, CurrentUserSelected, SiteDiscipline, configCatFlag } = useMst();
  const { isEditable, inspection } = useAccessOnTask();
  const { result: previousReportFiles } = usePreviousReportFiles();
  const { result: assetData, dynamicProperties: otherProperties } = useAssetDetails();
  const { inspectionFilesInitialized, inspectionFilesCollection, getInspectionFiles } =
    useInspectionFiles();
  const { selectedInspection } = useSelectedInspection(
    String(CurrentUserSelected.inspectionId),
    CurrentUserSelected.workPackageId,
  );
  const {
    lineandSectionPropertiesListInitialized,
    getLineandSectionPropertiesList,
    lineandSectionPropertiesListCollection,
  } = useLineAndSectionProperties();
  const { assetsByAreaHierarchyData } = useAssetsByAreaHierarchy();

  const [assetLocationDialog, setAssetLocationDialog] = useState<boolean>(false);
  const [assetButton, setAssetButton] = useState<string>('');
  const [assetName, setAssetName] = useState<string>('');
  const [openAuditLogs, setOpenAuditLogs] = useState<boolean>();
  // const [open, setOpen] = useState<boolean>(false);
  const [inspectionFilesDataDocument, setInspectionFilesDataDocument] = useState<
    InspectionFilesType[]
  >([]);
  const [openPreviousReportsDialog, setOpenPreviousReportsDialog] = useState(false);
  // const [plannedDeficiencyListDocument, setPlannedDeficiencyListDocument] = useState<
  //   PlannedDeficiencyListDocument[]
  // >([]);
  const [lineandSectionPropertiesList, setLineandSectionPropertiesList] = useState<
    LineandSectionPropertiesListDocument[]
  >([]);
  // const [plannedDeficienyListsubscription, setPlannedDeficienyListsubscription] =
  //   useState<Subscription>();

  const [selectedAssetId, setSelectedAssetId] = useState<string>();
  const [isReportDownloading, setIsReportDownloading] = useState(false);
  const [isOpenOfflineDialog, setIsOpenOfflineDialog] = useState(false);

  // const {
  //   plannedDeficiencyListInitialized,
  //   getPlannedDeficiencyList,
  //   plannedDeficiencyListCollection,
  // } = useExestingDeficiencyList();

  const isElectrical = SiteDiscipline.disciplineId === Discipline.Electrical;
  const isShaft = SiteDiscipline.disciplineId === Discipline.Shaft;

  const areaListFromRxDB = useMemo(() => {
    if (!inspection) return [];
    if (isShaft) {
      return [
        {
          id: String(inspection.areaId),
          name: inspection.assetName,
          areaName: inspection.assetName,
        },
      ] as MobileComponentLocationHeirarchy[];
    }
    return inspection.areaList || [];
  }, [isShaft, inspection]);

  const inspectionType = useMemo(() => {
    if (!inspection) return '-';
    setValueinLocalStorage('inspectionType', inspection?.assetInspectionType);
    return inspection ? inspection?.assetInspectionType : '-';
  }, [inspection]);

  const getInspectionFilesFromRxDB = async () => {
    if (inspectionFilesCollection) {
      const inspectionFilesRxDocument: InspectionFilesDocument[] = await getInspectionFiles();
      if (inspectionFilesRxDocument) {
        setInspectionFilesDataDocument(JSON.parse(JSON.stringify(inspectionFilesRxDocument)));
      }
    }
  };
  // const getPlannedDeficiencyListFromRxDB = async () => {
  //   if (plannedDeficiencyListCollection) {
  //     const plannedDeficiencyListDocumentList: PlannedDeficiencyListDocument[] =
  //       await getPlannedDeficiencyList();
  //     if (plannedDeficiencyListDocumentList) {
  //       setPlannedDeficiencyListDocument(
  //         JSON.parse(JSON.stringify(plannedDeficiencyListDocumentList)),
  //       );
  //     }
  //   }
  // };

  const getLineandSectionPropertiesListFromRxDB = async () => {
    if (lineandSectionPropertiesListCollection) {
      const lineandSectionPropertiesListDocument: LineandSectionPropertiesListDocument[] =
        await getLineandSectionPropertiesList();
      if (lineandSectionPropertiesListDocument) {
        setLineandSectionPropertiesList(
          JSON.parse(JSON.stringify(lineandSectionPropertiesListDocument)),
        );
      }
    }
  };

  // const subscribeToPlannedDeficiencyList = async () => {
  //   if (plannedDeficiencyListInitialized && plannedDeficiencyListCollection) {
  //     const plannedDeficiencyUpdateSub = plannedDeficiencyListCollection.find().$.subscribe(() => {
  //       getInspectionFilesFromRxDB();
  //     });
  //     setPlannedDeficienyListsubscription(plannedDeficiencyUpdateSub);
  //   }
  // };

  // useEffect(() => {
  //   if (plannedDeficiencyListInitialized) {
  //     getPlannedDeficiencyListFromRxDB();
  //     subscribeToPlannedDeficiencyList();
  //   }
  //   return () => {
  //     if (plannedDeficienyListsubscription) plannedDeficienyListsubscription.unsubscribe();
  //   };
  // }, [plannedDeficiencyListInitialized]);

  useEffect(() => {
    let subscription: Subscription;
    if (lineandSectionPropertiesListInitialized && lineandSectionPropertiesListCollection) {
      const queryObj = {
        selector: {
          assetId: { $eq: getValueFromLocalStorage('assetId') },
        },
      };
      subscription = lineandSectionPropertiesListCollection
        .find(queryObj)
        .$.subscribe(getLineandSectionPropertiesListFromRxDB);
    }
    return () => {
      subscription?.unsubscribe();
    };
  }, [
    lineandSectionPropertiesListInitialized,
    lineandSectionPropertiesListCollection,
    selectedAssetId,
  ]);

  useEffect(() => {
    let subscription: Subscription;
    if (inspectionFilesInitialized && inspectionFilesCollection) {
      const queryObj = {
        selector: {
          fkAssetInspectionTask: { $eq: CurrentUserSelected.taskId },
        },
      };
      subscription = inspectionFilesCollection
        .find(queryObj)
        .$.subscribe(getInspectionFilesFromRxDB);
    }
    return () => {
      subscription?.unsubscribe();
    };
  }, [inspectionFilesInitialized, inspectionFilesCollection, CurrentUserSelected.taskId]);

  const updateAssetLocationDialogStatus = async (LocationStatus: boolean) => {
    setAssetLocationDialog(LocationStatus);
  };

  const handleAuditLogs = () => {
    setOpenAuditLogs(!openAuditLogs);
  };

  useEffect(() => {
    if (
      HandleGesture.isNotificationClicked &&
      !!selectedInspection.assetId &&
      Number(selectedAssetId) !== selectedInspection.assetId
    ) {
      setValueinLocalStorage('assetId', selectedInspection.assetId);
      CurrentUserSelected.setAssetId(Number(selectedInspection.assetId));
      setSelectedAssetId(String(selectedInspection.assetId));
      HandleGesture.setIsNotificationClicked(false);
    }
  }, [selectedInspection]);

  // const handleOpen = () => {
  //   if (plannedDeficiencyListDocument.length > 0) {
  //     setOpen(true);
  //   } else {
  //     setOpen(false);
  //   }
  // };

  // const callback = useCallback(data => {
  //   setOpen(data);
  // }, []);

  const isPiping = useMemo(() => {
    return (assetData?.assetMainCategoryName || assetData?.assetCategoryName || '')
      ?.toLowerCase()
      .includes('piping');
  }, [assetData]);

  const downloadReport = async (payload: ReportInfoInput, reportFileName: string) => {
    try {
      const s3PathResult = await saveReportAndGetS3Path(payload);
      const filePath = s3PathResult?.data?.saveReportAndGetS3Path;
      const slicedFilePath = filePath.charAt(0) === '/' ? filePath.slice(1) : filePath;
      if (!slicedFilePath?.length) {
        throw new Error(JSON.stringify({ saveReportAndGetS3PathResult: s3PathResult, payload }));
      }
      const result = await getImage(slicedFilePath);
      const blobPath = await (await fetch(String(result))).blob();
      const path = URL.createObjectURL(blobPath);
      downloadURI(path, `${reportFileName}.pdf`);
    } catch (error) {
      errorNotification('Error while downloading report please try again');
      await trackEventFn(TrackingEventType.SERVICE_FAILED, {
        error: JSON.stringify(error),
      });
    } finally {
      setIsReportDownloading(false);
    }
  };

  const handleClickOnGenerateReport = async () => {
    if (!isOnline) {
      setIsOpenOfflineDialog(true);
      return;
    }
    if (isReportDownloading) return;
    setIsReportDownloading(true);
    const assetMainCategoryName =
      assetData?.assetMainCategoryName || assetData?.assetCategoryName || '';
    const assetSubCategoryName = assetData?.assetMainCategoryName
      ? assetData?.assetCategoryName || ''
      : '';

    const reportAssetName = assetData?.assetName;
    let reportFileName = `${reportAssetName}-${assetMainCategoryName}-${assetSubCategoryName}-${inspectionType}`;
    reportFileName = reportFileName.replace(/[\/\\[\]\:\|\<>\+\=\;\,\?\*]/g, '_');
    const payload = {
      reportName: 'InspectionReport',
      assetName: reportAssetName,
      pk_AssetInspection: CurrentUserSelected.inspectionId,
      pk_Schedule: CurrentUserSelected.workPackageId,
      scheduleName: '',
      logoPathSP_Header: '',
      logoPathSite_Header: '',
      disciplineName: getDisciplineById(SiteDiscipline.disciplineId),
      inspectionType,
      completionDate: null,
      reportFileName,
      assetMainCategoryName,
      assetCategoryName: assetSubCategoryName,
      isDraft: true,
      assetInspectionComponentFailureId: 0,
      siteId: SiteDiscipline.siteId,
      disciplineId: SiteDiscipline.disciplineId,
      hasAppendices: false,
    };

    await downloadReport(payload, reportFileName);
  };

  return (
    <>
      <div
        className={
          configCatFlag.getBlueBannerDisplay === true || configCatFlag.getRedBannerDisplay === true
            ? classes.root1 + ' scrollClass'
            : classes.root + ' scrollClass'
        }
      >
        <Card elevation={1} className={classes.card}>
          <Grid item container xs={12} alignItems="center" justifyContent="space-between">
            <Grid item xs={6} md={4} lg={4}>
              <Typography className="title">
                {isElectrical ? 'Preventative Maintenance Details' : 'Inspection Details'}
              </Typography>
            </Grid>
            <Grid xs={6} md={8} lg={8} container justifyContent="flex-end" alignItems="center">
              <Button onClick={handleAuditLogs} data-testid="inspection-details-audit-logs">
                <Typography color="primary" className="auditLogs">
                  Audit Log
                </Typography>
                <img
                  src={`${IMAGE_PATH}/customHistory.svg`}
                  alt="View"
                  className={classes.auditlogIcon}
                />
              </Button>
              <Grid item className={classes.dividerGrid}>
                <Divider orientation="vertical" className={classes.divider} />
              </Grid>
              <Typography
                color="primary"
                onClick={() => setOpenPreviousReportsDialog(true)}
                className={classes.reportText}
                data-testid="previous-report"
              >
                Previous Report
              </Typography>
              <Icons.DownloadFeather
                onClick={() => setOpenPreviousReportsDialog(true)}
                color="primary"
                className={classes.downlaod}
              />
              <Grid item className={classes.dividerGrid}>
                <Divider orientation="vertical" className={classes.divider} />
              </Grid>
              <Typography
                color="primary"
                onClick={handleClickOnGenerateReport}
                className={classes.reportText}
                data-testid="generate-report"
              >
                Generate Report
              </Typography>
              <Icons.DownloadFeather
                color="primary"
                onClick={handleClickOnGenerateReport}
                className={classes.downlaod}
              />
            </Grid>
          </Grid>
          <Grid className={`${classes.card} ${classes.subtitleGrid}`}>
            <Typography variant="h5" className={classes.subtitleGridText}>
              {`${isShaft ? 'Sub Area' : 'Asset'} Properties`}
            </Typography>
          </Grid>
          {assetData ? (
            <>
              <AssetProperties
                assetData={assetData}
                setAssetLocationDialog={setAssetLocationDialog}
                setAssetName={setAssetName}
                setAssetButton={setAssetButton}
                inspectionType={inspectionType}
                areaListFromRxDB={areaListFromRxDB}
              />
              {isElectrical && assetData?.etapFields?.length > 0 && (
                <EtapProperties etapFields={assetData?.etapFields[0]} />
              )}
            </>
          ) : (
            <Grid xs={12} className={classes.flexColumn}>
              <CircularProgress className={classes.progressMargin} />
            </Grid>
          )}

          {otherProperties?.length > 0 && <DynamicProperty otherProperties={otherProperties} />}

          {lineandSectionPropertiesList?.length > 0 && (
            <LineAndSectionProperties
              lineandSectionPropertiesListDocument={lineandSectionPropertiesList}
              assetsByAreaHierarchyData={assetsByAreaHierarchyData}
              isPiping={isPiping}
            />
          )}

          {/* <Grid
            className={`${classes.card} ${classes.inspectioFileGrid}`}
            xs={12}
            container
            onClick={handleOpen}
          >
            <Grid item xs={6}>
              <Typography variant="h5" className={classes.deficiency}>
                {`Deficiencies in Planning  (${plannedDeficiencyListDocument?.length})`}
              </Typography>
            </Grid>
            {plannedDeficiencyListDocument.length > 0 && (
              <Grid item xs={6}>
                <Grid container justifyContent="flex-end" alignItems="center">
                  <Icons.ChevronRightFeather color="primary" />
                </Grid>
              </Grid>
            )}
            {open && (
              <PlannedDeficiency
                plannedDeficiencyListDocument={plannedDeficiencyListDocument}
                open={open}
                parentCallback={callback}
              />
            )}
          </Grid> */}

          {inspectionFilesDataDocument && (
            <InspectionFiles
              inspectionFilesDataDocument={inspectionFilesDataDocument}
              isEditable={isEditable}
            />
          )}
        </Card>
      </div>

      {assetLocationDialog && !isElectrical && (
        <AssetLocationDetails
          assetLocationDialogTree={assetLocationDialog}
          updateAssetLocationDialogStatus={updateAssetLocationDialogStatus}
          assetButton={assetButton}
          assetName={assetName}
          assetsByAreaHierarchyData={assetsByAreaHierarchyData}
          areaListFromRxDB={areaListFromRxDB}
          assetLocationName=""
        />
      )}
      {assetLocationDialog && isElectrical && (
        <ElectricalAssetLocationDetails
          assetLocationDialogTree={assetLocationDialog}
          updateAssetLocationDialogStatus={updateAssetLocationDialogStatus}
          assetButton={assetButton}
          assetName={assetName}
          assetsByAreaHierarchyData={assetsByAreaHierarchyData}
          areaListFromRxDB={areaListFromRxDB}
          assetLocationName=""
        />
      )}
      {openAuditLogs && (
        <Auditlogs
          open={openAuditLogs}
          onClose={handleAuditLogs}
          title="Task"
          subTitle="Inspection"
          deficiencyId={0}
          isUpdateHistory={false}
          isActiveDeficiency={false}
        />
      )}
      {openPreviousReportsDialog && (
        <PreviousReports
          open={openPreviousReportsDialog}
          onClose={() => setOpenPreviousReportsDialog(false)}
          reports={previousReportFiles}
        />
      )}
      {isOpenOfflineDialog && (
        <OfflineDialog onClose={() => setIsOpenOfflineDialog(false)} open={isOpenOfflineDialog} />
      )}
    </>
  );
};
export default observer(InspectionDetails);
